export default __webpack_public_path__ + "static/logo-white-ffce7f2813d924cf31731cfa36b980af.png";